import { axios } from '@/utils/request'

const API = {
  getLiveClassesInfo: '/b/classes/live/getLiveClassesInfo',
  getLiveClassesInfoV2: '/b/classes/live/v2/getLiveClassesInfo',
  getLiveCalendar: '/b/classes/live/v2/getLiveCalendar',
  getLiveObjByScheduleId: '/b/classes/biz/classes/schedule/getById/bjy'
}

export const getLiveClassesInfo = data => {
  return axios({
    url: API.getLiveClassesInfoV2,
    method: 'GET'
  })
}
export const getLiveCalendar = data => {
  return axios({
    url: API.getLiveCalendar,
    method: 'POST',
    data
  })
}
export const getLiveObjByScheduleId = data => {
  return axios({
    url: API.getLiveObjByScheduleId,
    method: 'GET',
    params: data
  })
}
